import { IconButton, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import CheckIcon from "@material-ui/icons/Check";
import React, { useState } from "react";

import { tokens } from "../console/tokens";

const useStyles = makeStyles(() => ({
    wrap: {
        position: "relative",
    },
    pre: {
        margin: 0,
        padding: "16px 44px 16px 18px",
        background: tokens.ink,
        color: "#e7ecf7",
        borderRadius: "8px",
        fontFamily: "ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
        fontSize: "12.5px",
        lineHeight: 1.6,
        overflowX: "auto",
    },
    copyBtn: {
        position: "absolute",
        top: "8px",
        right: "8px",
        color: "#a3aec8",
        "&:hover": {
            color: "#e7ecf7",
        },
    },
}));

interface Props {
    data: unknown;
}

export const SectionJsonView: React.FC<Props> = ({ data }) => {
    const classes = useStyles();
    const [copied, setCopied] = useState(false);
    const json = JSON.stringify(data, null, 2);

    const handleCopy = () => {
        navigator.clipboard.writeText(json).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        });
    };

    return (
        <div className={classes.wrap}>
            <Tooltip title={copied ? "Copied" : "Copy JSON"}>
                <IconButton size="small" className={classes.copyBtn} onClick={handleCopy}>
                    {copied ? <CheckIcon fontSize="small" /> : <FileCopyOutlinedIcon fontSize="small" />}
                </IconButton>
            </Tooltip>
            <pre className={classes.pre}>{json}</pre>
        </div>
    );
};
